import ProfilePage from './components/ProfilePage'
export default ProfilePage
